<template>
  <div class="wrap relative" v-if="ready" data-sticky-container>
    <site-header bg="false"></site-header>

    <ContentSection skew="right" id="products" class="z-1 pb-12 bg-grimacepurple-600">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <h1 class="text-3xl md:text-4xl text-white">Pipefish products</h1>
          <h2 class="text-4xl md:text-6xl text-white mt-3 pb-3" v-html="data.name"></h2>
        </div>
      </div>
    </ContentSection>

    <!-- <ContentSection skew="right" id="product" class="section z-30 bg-grimacepurple-400 mt-0 py-12">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <h2 class="text-4xl md:text-6xl text-white -mt-5" v-html="data.name"></h2>
        </div>
      </div>
    </ContentSection> -->

    <!-- <ContentSection skew="none" id="product0" class="section z-25 bg-white mt-0 py-12"> -->
    <CISynchronizer v-bind:productName="data.name" />
    <!-- </ContentSection> -->

    <!-- <div class="product-wrap">
      <p class="text-sm font-light pt-12" v-html="data.updated"></p>

      <CISynchronizer v-bind:productName="data.name" />
    </div> -->
    <SiteFooter></SiteFooter>
    <ProductRegister></ProductRegister>
    <ProductRegisterBackdrop></ProductRegisterBackdrop>
  </div>
</template>

<script>
import Sticky from 'sticky-js';
import _ from 'lodash';

import SiteHeader from '@/components/SiteHeader.vue';
import SiteFooter from '@/components/Footer.vue';
import ProductRegister from '@/components/ProductRegister.vue';
import ProductRegisterBackdrop from '@/components/ProductRegisterBackdrop.vue';
import ContentSection from '@/components/ContentSection.vue';
import CISynchronizer from '@/components/products/CISynchronizer.vue';

import '@/components/svg/icon-check';
import '@/components/svg/chevron-left';
import '@/components/svg/chevron-right';

export default {
  name: 'Products',
  components: {
    SiteHeader,
    SiteFooter,
    ProductRegister,
    ProductRegisterBackdrop,
    ContentSection,
    CISynchronizer
  },
  data: function() {
    return {
      ready: false,
      data: null,
      publicPath: process.env.BASE_URL
    };
  },
  computed: {},
  methods: {
    toggleProductRegisterModal: function(title) {
      this.Store.toggleProductRegisterModal({ title: title });
    },
    getData: function() {
      var vm = this;

      this.data = _.find(vm.Store.products, function(item) {
        return item.slug === vm.$route.params.product;
      });
      this.ready = true;
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.getData();
      setTimeout(function() {
        this.sticky = new Sticky('.cisSticky');
      }, 300);
    });
  }
};
</script>

<style lang="scss">
.sect-p-need {
  z-index: 310;
  @include media('>950px') {
  }
  .sect-content {
    width: 100%;
    @include media('>=420px') {
      margin-bottom: 40px;
    }
  }
}

.sect-p-inclusions {
  transform: skewY($-skew) translateY(0px);
  background: rgba($Grey1WhiteSmoke, 0.7);
  color: #222;
  position: relative;
  z-index: 70;
  padding-bottom: 70px;
  .inner {
    .sect-content {
      transform: skewY($skew) translateY(0px);
      width: 100%;
      @include media('>950px') {
        // width: 50%; TODO only if images don't want to work nicely?
      }

      .list-wrap {
        @include media('<950px', '>600px') {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
        }
        ul {
          list-style: none;
          padding: 0;
          margin: 0 0 0 0;
          width: 100%;
          @include media('>400px') {
            margin-right: 40px;
          }

          &.first {
            margin-top: 60px;
            @include media('<950px', '>600px') {
              margin-top: 30px;
            }
          }
          &.second {
            @include media('<950px', '>600px') {
              margin-top: 30px;
            }
          }

          li {
            list-style: none;
            padding: 0 0 15px 25px;
            margin: 0;
            position: relative;
            // font-size: 17px;
            > svg {
              position: absolute;
              top: 4px;
              left: 0px;
              width: 15px;
              height: 15px;
            }

            @include media('>=medium') {
              padding-left: 40px;
              // font-size: 18px;
              > svg {
                top: 6px;
                width: 15px;
                height: 15px;
              }
            }
          }
        }
      }
    }
  }
}

.product-wrap li {
  font-size: 0.75rem;
  padding: 0.5rem;
}

.product-wrap ul,
ol,
li {
  padding-left: 10px;
}

.product-wrap li::marker {
  font-size: 1rem;
}

.product-wrap span {
  font-size: 1rem;
}
</style>
